var _rect, _rect2, _g, _rect3, _rect4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dailer - Contacts (add/remove/view) and account details",
    clipPath: "url(#clip0_303_2)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2350,
    height: 2258,
    transform: "translate(-586 -1058)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 265",
    filter: "url(#filter0_d_303_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -286,
    y: -114,
    width: 318,
    height: 444,
    rx: 12,
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 267",
    x: -286,
    y: -16,
    width: 318,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_303_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#07AA3F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_303_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "refresh_2",
    d: "M7.99984 13.3337C6.51095 13.3337 5.24984 12.817 4.2165 11.7837C3.18317 10.7503 2.6665 9.48921 2.6665 8.00033C2.6665 6.51144 3.18317 5.25033 4.2165 4.21699C5.24984 3.18366 6.51095 2.66699 7.99984 2.66699C8.7665 2.66699 9.49984 2.82533 10.1998 3.14199C10.8998 3.45866 11.4998 3.91144 11.9998 4.50033V2.66699H13.3332V7.33366H8.6665V6.00033H11.4665C11.1109 5.3781 10.6248 4.88921 10.0082 4.53366C9.3915 4.1781 8.72206 4.00033 7.99984 4.00033C6.88873 4.00033 5.94428 4.38921 5.1665 5.16699C4.38873 5.94477 3.99984 6.88921 3.99984 8.00033C3.99984 9.11144 4.38873 10.0559 5.1665 10.8337C5.94428 11.6114 6.88873 12.0003 7.99984 12.0003C8.85539 12.0003 9.62762 11.7559 10.3165 11.267C11.0054 10.7781 11.4887 10.1337 11.7665 9.33366H13.1665C12.8554 10.5114 12.2221 11.4725 11.2665 12.217C10.3109 12.9614 9.22206 13.3337 7.99984 13.3337Z",
    fill: "#07AA3F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_303_2",
    x: -290,
    y: -114,
    width: 326,
    height: 452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_303_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_303_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2350,
    height: 2258,
    fill: "white",
    transform: "translate(-586 -1058)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.81e6e222382941a2f075d5649ecd1bbb.svg";
export { ForwardRef as ReactComponent };